import { render } from "./UnitsComponent.vue?vue&type=template&id=739b284e&scoped=true"
import script from "./UnitsComponent.vue?vue&type=script&lang=js"
export * from "./UnitsComponent.vue?vue&type=script&lang=js"

import "./UnitsComponent.vue?vue&type=style&index=0&id=739b284e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-739b284e"]])

export default __exports__